export type MaterialConfirmGateResult = 'invalid_quantity' | 'confirm_zero_rate' | 'ok';

/**
 * Confirm-gate for material lines (inbox queue confirm + manual add). The
 * server deliberately stays permissive — a $0 no-charge/transparency line is a
 * legitimate business decision — so the gate lives client-side and asks for an
 * explicit second confirmation instead of blocking.
 */
export function materialConfirmGate(args: {
  quantity: number;
  rateCents: number;
  zeroRateAcknowledged: boolean;
}): MaterialConfirmGateResult {
  if (!Number.isFinite(args.quantity) || args.quantity <= 0) return 'invalid_quantity';
  if (args.rateCents === 0 && !args.zeroRateAcknowledged) return 'confirm_zero_rate';
  return 'ok';
}
